import { emailOnlyRequestSchema, type EmailOnlyRequest } from '@koderek/shared';
import { zodResolver } from '@hookform/resolvers/zod';
import { Alert, Button, Stack, TextInput } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { api } from '../api/client';
import { AuthCard } from '../features/auth/AuthCard';
import { errorMessage } from '../features/auth/session';
import { t } from '../texts/pl';

/** US-206 AC-1: zawsze ten sam komunikat – nie zdradzamy, czy konto istnieje. */
export function ForgotPasswordPage() {
  const form = useForm<EmailOnlyRequest>({ resolver: zodResolver(emailOnlyRequestSchema) });
  const request = useMutation({ mutationFn: (body: EmailOnlyRequest) => api('POST', '/auth/password-reset', { body }) });

  return (
    <AuthCard title={t.forgot.title} intro={request.isSuccess ? undefined : t.forgot.intro}>
      {request.isSuccess ? (
        <Alert color="green" role="status">
          {t.forgot.done}
        </Alert>
      ) : (
        <form onSubmit={form.handleSubmit((values) => request.mutate(values))} noValidate>
          <Stack gap="sm">
            <TextInput label={t.fields.email} type="email" autoComplete="email" required {...form.register('email')} error={form.formState.errors.email?.message} />
            {request.isError ? (
              <Alert color="red" role="alert">
                {errorMessage(request.error)}
              </Alert>
            ) : null}
            <Button type="submit" loading={request.isPending}>
              {t.forgot.submit}
            </Button>
          </Stack>
        </form>
      )}
    </AuthCard>
  );
}
